import { Modal as MuiModal } from '@mui/material';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { approvalAiCarryOverAtom } from '@/components/Approval/ApprovalView/atoms';
import { ActionButton, Body, Dialog, Header, Title } from './styles';

/**
 * 결재 완료 후 "다음 결재 문서 열기" 확인 레이어 (레거시 apprAfterConfirmModal 복원).
 * 큐에 네이티브/iframe 문서가 섞여 레거시 레이어와 번갈아 뜨므로 포탈 표준 모달 대신 레거시 외형 유지.
 */

type NextApprovalConfirmModalProps = {
  open: boolean;
  onOpenNext: () => void;
  onClose: () => void;
};

const TriangleRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M4 2l7 5-7 5z" fill="currentColor" />
  </svg>
);

const CloseCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
    <circle cx="8" cy="8" r="8" fill="#000000" />
    <path
      d="M5.5 5.5l5 5M10.5 5.5l-5 5"
      stroke="#ffffff"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const NextApprovalConfirmModal = ({
  open,
  onOpenNext,
  onClose,
}: NextApprovalConfirmModalProps) => {
  const { t } = useTranslation();
  const setAiCarryOver = useSetAtom(approvalAiCarryOverAtom);
  // 「닫기」(바깥 클릭·Esc 포함)면 다음 문서로 가지 않으므로 AI 패널 이어 열기도 취소 (PORTAL-15735)
  const handleClose = () => {
    setAiCarryOver(null);
    onClose();
  };

  return (
    // 결재 AI 어시스턴트 패널(1350) 위 — 패널에서 결재해도 이 안내가 가려지지 않게. 토스트(1400)보다는 아래 (PORTAL-15735)
    <MuiModal open={open} onClose={handleClose} sx={{ zIndex: 1360 }}>
      <Dialog>
        <Header>
          <Title>{t('결재가 완료 되었습니다.')}</Title>
        </Header>
        <Body>
          <ActionButton type="button" tone="primary" onClick={onOpenNext}>
            <TriangleRightIcon />
            {t('다음 결재 문서 열기')}
          </ActionButton>
          <ActionButton type="button" tone="default" onClick={handleClose}>
            <CloseCircleIcon />
            {t('닫기')}
          </ActionButton>
        </Body>
      </Dialog>
    </MuiModal>
  );
};

export default NextApprovalConfirmModal;
